module.exports = __webpack_public_path__ + "img/soundwave_bckg_green.b09f16be.png";